import React from 'react';

import Router from '../../containers/Routes/Router';
import routesConfig from './routesConfig';

const PageAccount: React.FC = () => (
  <Router config={routesConfig} />
);

export default PageAccount;
